// CAP-013 / REQ-TESTREF-008 — locales with full "Locale recognition test text"
// coverage on the primary invoice PDF. Mirrors the backend profile registry.
export const SUPPORTED_LOCALE_RECOGNITION_LOCALES: ReadonlySet<string> = new Set([
  'nl-NL',
  'nl-BE',
  'fr-BE',
  'de-DE',
  'fr-FR',
  'en-GB',
  'da-DK',
  'it-IT',
  'de-CH',
  'fr-CH',
  'it-CH',
])

export function localeSupportsRecognitionText(locale: string): boolean {
  return SUPPORTED_LOCALE_RECOGNITION_LOCALES.has(locale)
}
